;(function() {
    var

    isSearching = false,

    $mContainer = null,

    $pageNumber = null,
    $pageCount = null,
    $recordCount = null,

    //
    //init
    //
    init = function() {
        $mContainer = $('.layout-gallery');

        if ($mContainer.length > 0) {
            $pageNumber = $('#pageNumber');
            $pageCount = $('#pageCount');
            $recordCount = $('#recordCount');


            // setup
            setupButtons();
            setupLoadMore();
            setupSearchFilterToggle();
            setupGalleryItems();

            // do the initial search
            doSearch();
        }
    },

    //
    // setup the button handlers
    //
    setupButtons = function() {

        // search
        $('.btnSearch').click(function() {
            // clear the search results
            clearSearch();

            // do search
            doSearch();
        });

        // reset
        $('.btnReset').click(function() {
            window.location = '/gallery/';
        });
    },

    //
    // load more search results if the user scrolls near the bottom of the page
    //
    setupLoadMore = function() {
        $(window).scroll(function() {

            // if near the bottom of the page
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {

                // search for more records
                doSearch();
            }
        });
    },

    //
    // setup show/hide search filters
    //
    setupSearchFilterToggle = function() {
        $('.search-filter-toggle').on('click', function() {
            $('.search-filters').toggle();
        });
    },

    //
    // Clear the search results and reset the counts
    //
    clearSearch = function() {
        $('.search-results').html('');

        //reset the pager values
        $pageNumber.val(0);
        $pageCount.val(-1);
        $recordCount.val(0);
    },

    //
    // do the search
    //
    doSearch = function() {
        return new Promise(function(resolve, reject) {
            if (!isSearching) {
                var pageNumber = parseInt($pageNumber.val());
                var pageCount = parseInt($pageCount.val());

                // if there are more records to search for
                if (pageCount == -1 || pageNumber < pageCount) {
                    isSearching = true;

                    // show loading
                    showLoading();

                    // disable the command buttons
                    $('.btnSearch, .btnReset').prop('disabled', true);

                    // search params
                    var data = {
                        c: {
                            Term: $('#c_Term').val(),
                            OrganizationID: $('#c_OrganizationID').val(),
                            UserID: $('#c_UserID').val(),
                            RegistrationYearID: $('#c_RegistrationYearID').val(),
                            City: $('#c_City').val(),
                            Country: $('#c_Country').val(),
                            AgeFrom: $('#c_AgeFrom').val(),
                            AgeTo: $('#c_AgeTo').val(),
                            HasAudioFile: $('#c_HasAudioFile').prop('checked')
                        },
                        pageNumber: pageNumber + 1
                    };

                    $.post(
                        '/gallery/search',
                        data,
                        function(res) {
                            // update the search results
                            $('.search-results').append(res.html);

                            //update the hidden paging fields
                            $pageNumber.val(res.pageNumber);
                            $pageCount.val(res.pageCount);
                            $recordCount.val(res.recordCount);

                            // re-enable the command buttons
                            $('.btnSearch, .btnReset').prop('disabled', false);

                            // hide loading
                            hideLoading();

                            isSearching = false;
                            resolve();
                        }
                    );

                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        });
    },

    //
    // Setup gallery item detail page click
    //
    setupGalleryItems= function() {

        // hover
        $mContainer.on('mouseover', '.gallery-col', function() {
            $('.gallery-info', this).addClass('hover');
        })
        $mContainer.on('mouseout', '.gallery-col', function() {
            $('.gallery-info', this).removeClass('hover');
        })

        // click
        $mContainer.on('click', '.gallery-col', function() {
            var flagId = $(this).attr('data-flag-id');
            var flagIndex = parseInt($(this).attr('data-flag-index'));
            var flagTotalCount = parseInt($recordCount.val());

            // modal element
            var mdl = $('<div class="layout-gallery-detail-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">' +
                            '<div class="modal-dialog" role="document">' +
                                '<div class="modal-content">' +
                                    '<div class="modal-header text-center pt7 pr10 pb5 pl5">' +
                                        '<span class="flag-count pl5"></span>' +
                                        '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>' +
                                    '</div>' +
                                    '<div class="modal-body">' + 
                                        '<div class="well mr10">Loading . . .</div>' + 
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>');
            $('body').append(mdl);

            // open the modal
            mdl.modal('show');

            // on shown
            mdl.on('shown.bs.modal', function (e) {

                // get the detail content
                loadFlagDetail(mdl, flagId, flagIndex, flagTotalCount);
            });

            // on hidden
            mdl.on('hidden.bs.modal', function (e) {
                mdl.remove();
            });
        });
    },

    //
    // reset the modal content for loading a new flag
    //
    resetModalContent = function(mdl) {
        // clear the current content
        $('.modal-header .flag-count', mdl).html('');
        $('.modal-body', mdl).html('<div class="well mr10">Loading . . .</div>');
    },

    //
    // Get the content for a flag and update the modal
    //
    loadFlagDetail = function(mdl, flagId, flagIndex, totalCount) {
        resetModalContent();

        var url = '/gallery/detailpopup/' + flagId + '/';

        // get the detail content
        $.get(url, function(res) {
            $('.modal-header .flag-count', mdl).html((flagIndex + 1) + '/' + totalCount);
            $('.modal-body', mdl).html(res);

            // setup prev/next click
            setupPrevNextClick(mdl, flagIndex, totalCount);

            // setup audio link click
            adc.gallery_detail.setupAudioLinkClick();

            // load the AddThis share buttons
            adc.gallery_detail.loadShareButtons();
        });
    },

    //
    // setup the prev/next button click to through cycle flags
    //
    setupPrevNextClick = function(mdl, idx, totalCount) {

        // show prev/next links
        idx = parseInt(idx);
        if (idx > 0) {
            $('.prev', mdl).show();
        }
        if ((idx + 1) < totalCount) {
            $('.next', mdl).show();
        }

        // click
        $('.prev, .next', mdl).unbind('click');
        $('.prev, .next', mdl).bind('click', function() {

            // get the direction and next index
            var dir = parseInt($(this).attr('data-direction'));
            var nextIdx = idx + dir;

            // get the id of the next flag
            var nextFlagId = $('.layout-gallery .gallery-col[data-flag-index=' + nextIdx + ']').attr('data-flag-id');

            // check to see if we need to load more flags
            if (!nextFlagId && dir > 0 && (nextIdx + 1) <= totalCount) {

                // reset the content while searching
                resetModalContent();

                // search
                doSearch().then(function() {

                    // get the id of the next flag
                    nextFlagId = $('.layout-gallery .gallery-col[data-flag-index=' + nextIdx + ']').attr('data-flag-id');

                    // load the next flag
                    loadFlagDetail(mdl, nextFlagId, nextIdx, totalCount);
                });
            }

            // if there is a next flag id
            if (nextFlagId) {

                // load the next flag
                loadFlagDetail(mdl, nextFlagId, nextIdx, totalCount);
            }
        });

        // left/right keyboard arrows
        $(document).keydown(function(e) {
            e.preventDefault(); // prevent the default action (scroll / move caret)
            switch(e.which) {
                case 37: // left
                // case 38: // up
                    $('.prev').click();
                break;

                case 39: // right
                // case 40: // down
                    $('.next').click();
                break;

                default: return; // exit this handler for other keys
            }
        });        
    },

    showLoading = function() {
        // interval for loading animation
        var i = 0;
        var text = "Loading";
        $(".search-loading-content").html(text);
        $(".search-loading").show();
        var tmr = setInterval(function() {
            if ($('.search-loading').is(':visible')) {
                $(".search-loading-content").html(text+Array((++i % 6)+1).join(" . "));
            }
            else {
                clearInterval(tmr);
            }
        }, 500);
    },

    hideLoading = function() {
        $(".search-loading").hide();
    };

    //call init
    $(document).ready(init);

})();